import type { RoleConfig } from '../types.js';

export const civilian: RoleConfig = {
  id: 'civilian',
  faction: 'town',
  title: { ru: 'Мирный житель', uk: 'Мирний житель' },
  latin: 'CIVILIAN',
  number: '01',
  accent: '#c8d0d6',
  sub: '#5b6168',
  ability: {
    ru: 'Просыпается утром. Голосует днём.',
    uk: 'Прокидається вранці. Голосує вдень.',
  },
  abilities: [],
  victory: { type: 'town' },
};
